import React from "react";
import "../../css/terms.scss";
import Header from "./Header";
import Footer from "./Footer";

const Accessibility = () => {
  return (
    <div>
      <Header />

      <main className="accessibility-main">
        <div className="accessibility-center">
          <h1 className="accessibility-title">Accessibility Statement</h1>
        </div>

        <div className="accessibility-columns">
          <div>
            <h4>Our Commitment to Accessibility</h4>
            <p>
              We are committed to making our website’s content accessible and
              user friendly to everyone.
            </p>

            <p>
              If you are having difficulty viewing or navigating the content on
              this website, or notice any content, feature, or functionality
              that you believe is not fully accessible to people with
              disabilities, please email us at{" "}
              <a href="mailto:adacompliance@gofundme.com">
                adacompliance@gofundme.com
              </a>{" "}
              with “Disabled Access” in the subject line and provide a
              description of the specific feature you feel is not fully
              accessible or a suggestion for improvement.
            </p>
          </div>

          <div>
            <p>
              We take your feedback seriously and will consider it as we
              evaluate ways to accommodate all of our customers and our overall
              accessibility policies.
            </p>

            <p>
              Additionally, while we do not control such vendors, we strongly
              encourage vendors of third-party digital content to provide
              content that is accessible and user friendly.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Accessibility;
